(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4229],{

/***/ 19714:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcast/[slug]",
      function () {
        return __webpack_require__(96592);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12052:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/carbon_play-filled.d63195ae.png","height":32,"width":32,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEUQtf8Qtf9MaXEQtv8Qtf8Qtv8Qtv8Qtf/5KH/ZAAAAB3RSTlNzLQCEqB/3aAVykwAAAAlwSFlzAAALEwAACxMBAJqcGAAAACpJREFUeJxFizEOACAMhOhV5f8/drJuJABJQSUEVUK5+miBZLd8GDXx2y8c4ADNigP2iQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 6555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var HtmlData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: data
            },
            className: "paragraphs"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HtmlData);


/***/ }),

/***/ 96592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/Shared/HtmlData/HtmlData.tsx
var HtmlData = __webpack_require__(6555);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./styles/images/carbon_play-filled.png
var carbon_play_filled = __webpack_require__(12052);
;// CONCATENATED MODULE: ./styles/images/image 2.png
/* harmony default export */ var image_2 = ({"src":"/_next/static/media/image 2.1fa0f63a.png","height":41,"width":152,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEX19fXj5OXb3N/p7dzV1tfs49vu7u/KzMzm6O2H1s73AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgZeZgZGNgYGBgZWZiZ2FiYQQAAfYANP92gZgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./styles/images/image 1.png
/* harmony default export */ var image_1 = ({"src":"/_next/static/media/image 1.540390b7.png","height":41,"width":145,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEXHx8fv7+/Sl+vlk/W6vbjV2NXdxOXg3+CWDmFXAAAABXRSTlP+/fr4/n9QZF8AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVHicY2BmY2VnZGRkZGBiY2FgZWBgAAAB5gArEMbZwQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./styles/images/basil_share-outline.png
/* harmony default export */ var basil_share_outline = ({"src":"/_next/static/media/basil_share-outline.25c64d8b.png","height":24,"width":24,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEWampqampqbm5uampqampqbm5ubm5syH/gsAAAAB3RSTlMCiDltITs2n+LOmwAAAAlwSFlzAAALEwAACxMBAJqcGAAAACtJREFUeJw1yckNACAQw8DZA/ovGXHlYUsOe9lHMuK7UIeI13WOe2H+aLQFB3oAPcrINZIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./styles/images/Group 17.png
/* harmony default export */ var Group_17 = ({"src":"/_next/static/media/Group 17.05efc53c.png","height":389,"width":1440,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAACVBMVEUNDgoiJRkUGBFeBuywAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGElEQVR4nAXBAQEAAACCIOz/6ACqYavNAQB8ABCK2BqdAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./styles/images/x-twitter.svg
/* harmony default export */ var x_twitter = ({"src":"/_next/static/media/x-twitter.377a7df0.svg","height":512,"width":512});
;// CONCATENATED MODULE: ./styles/images/facebook-f.svg
/* harmony default export */ var facebook_f = ({"src":"/_next/static/media/facebook-f.fd8679db.svg","height":512,"width":320});
;// CONCATENATED MODULE: ./styles/images/whatsapp.svg
/* harmony default export */ var whatsapp = ({"src":"/_next/static/media/whatsapp.1f86b298.svg","height":512,"width":448});
// EXTERNAL MODULE: ../../node_modules/next-share/dist/next-share.es.js
var next_share_es = __webpack_require__(41967);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./styles/images/circle-pause-solid (1).svg
/* harmony default export */ var circle_pause_solid_1_ = ({"src":"/_next/static/media/circle-pause-solid (1).15766a45.svg","height":512,"width":512});
;// CONCATENATED MODULE: ./pages/podcast/[slug].tsx
















var Podcast = function(param) {
    var episode = param.episode, title = param.title, description = param.description, googlePodcastLink = param.googlePodcastLink, applePodcastLink = param.applePodcastLink, imgUrl = param.imgUrl, PodcastBannerImg = param.PodcastBannerImg, name = param.name, innerImgUrl = param.innerImgUrl, total = param.total;
    var ref = (0,react.useState)(null), activeEpisodeIndex = ref[0], setActiveEpisodeIndex = ref[1];
    var ref1 = (0,react.useState)(null), activeShareIndex = ref1[0], setActiveShareIndex = ref1[1];
    var ref2 = (0,react.useState)(null), totalEpisode = ref2[0], setTotalEpisode = ref2[1];
    var ref3 = (0,react.useState)(true), hasMore = ref3[0], setHasMore = ref3[1];
    var ref4 = (0,react.useState)([]), segments = ref4[0], setSegments = ref4[1];
    var perPage = 10;
    var currentPage = (0,react.useRef)(0);
    var toggleAudioVisibility = function(index) {
        setActiveEpisodeIndex(index === activeEpisodeIndex ? null : index);
        setActiveShareIndex(null);
    };
    var toggleShareVisibility = function(index) {
        setActiveShareIndex(index === activeShareIndex ? null : index);
        setActiveEpisodeIndex(null);
    };
    (0,react.useEffect)(function() {
        setTotalEpisode(total);
    }, [
        total
    ]);
    (0,react.useEffect)(function() {
        console.log("RELOADING");
        currentPage.current = 0;
        loadMoreEpisodes();
    }, [
        episode
    ]);
    (0,react.useEffect)(function() {
        console.log("segments===>", segments);
    }, [
        segments
    ]);
    var loadMoreEpisodes = function() {
        var nextPage = currentPage.current + 1;
        var newSegments = episode.slice(0, nextPage * perPage);
        setSegments(newSegments);
        currentPage.current = nextPage;
        setHasMore(newSegments.length < total);
    };
    var asPath = (0,router.useRouter)().asPath;
    var origin =  true && window.location.origin ? window.location.origin : "";
    var URL = "".concat(origin).concat(asPath);
    var handlePage = function() {
        console.log("GETTTING MOre");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mt-4 mb-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "img-fluid",
                            style: {
                                backgroundColor: "black"
                            },
                            src: Group_17
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "PageBuilder-pageRow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                style: {
                                    padding: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            width: "100%",
                                            padding: "14px 1%",
                                            marginBottom: "1%",
                                            borderRadius: "14px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    opacity: "0.7"
                                                },
                                                children: description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "podcastLegend",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "podcastSubLedgend",
                                                children: "متاح على"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    padding: "2%",
                                                    paddingTop: "3%",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    width: "100%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: googlePodcastLink,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            style: {
                                                                cursor: "pointer"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: image_2
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: applePodcastLink,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            style: {
                                                                cursor: "pointer",
                                                                paddingRight: "20%"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: image_1
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        style: {
                                            margin: "2%",
                                            opacity: "0.8"
                                        },
                                        children: "".concat(episode.length, " حلقات")
                                    }),
                                    segments.map(function(item, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                            className: "podcastList",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "newsText",
                                                    style: {
                                                        width: "50%",
                                                        flex: "3 1",
                                                        padding: "5px 5px 0"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            style: {
                                                                opacity: "0.8",
                                                                lineHeight: "21.78px"
                                                            },
                                                            children: item.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlData/* default */.Z, {
                                                            data: item.description
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "infoItem",
                                                            children: item.createdAt
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            style: {
                                                                marginBottom: "1%",
                                                                paddingTop: "12%",
                                                                borderBottom: "2px solid #D6D6D6"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                justifyContent: "space-between"
                                                            },
                                                            children: [
                                                                activeEpisodeIndex !== index && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: carbon_play_filled/* default */.Z,
                                                                    onClick: function() {
                                                                        return toggleAudioVisibility(index);
                                                                    }
                                                                }),
                                                                activeEpisodeIndex === index && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "podcastPauseIcon",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: circle_pause_solid_1_,
                                                                                width: 32,
                                                                                height: 32,
                                                                                onClick: function() {
                                                                                    return toggleAudioVisibility(index);
                                                                                }
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "podcastAudio",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("audio", {
                                                                                autoPlay: true,
                                                                                controls: true,
                                                                                style: {
                                                                                    width: "100%"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                                                        src: item.episodeUrl,
                                                                                        type: "audio/mpeg"
                                                                                    }),
                                                                                    "Your browser does not support the audio element."
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                activeShareIndex !== index && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: basil_share_outline,
                                                                        style: {
                                                                            cursor: "pointer"
                                                                        },
                                                                        onClick: function() {
                                                                            return toggleShareVisibility(index);
                                                                        }
                                                                    })
                                                                }),
                                                                activeShareIndex === index && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        height: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            style: {
                                                                                cursor: "pointer",
                                                                                fontSize: "X-large"
                                                                            },
                                                                            onClick: function() {
                                                                                return toggleShareVisibility(null);
                                                                            },
                                                                            children: "✕"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "podcastIcon",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* TwitterShareButton */.B, {
                                                                                    url: URL,
                                                                                    title: item === null || item === void 0 ? void 0 : item.title,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                        className: "",
                                                                                        width: 25,
                                                                                        height: 25,
                                                                                        style: {
                                                                                            margin: "0.1em",
                                                                                            backgroundColor: "white",
                                                                                            borderRadius: "50%",
                                                                                            cursor: "pointer"
                                                                                        },
                                                                                        src: x_twitter
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(next_share_es/* FacebookShareButton */.Dk, {
                                                                                    url: URL,
                                                                                    quote: item === null || item === void 0 ? void 0 : item.title,
                                                                                    hashtag: "#cnbc",
                                                                                    children: [
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                            className: "",
                                                                                            width: 25,
                                                                                            height: 25,
                                                                                            src: facebook_f,
                                                                                            style: {
                                                                                                margin: "0.1em",
                                                                                                padding: "5%",
                                                                                                backgroundColor: "white",
                                                                                                borderRadius: "50%",
                                                                                                cursor: "pointer"
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* WhatsappShareButton */.N0, {
                                                                                    url: URL,
                                                                                    title: item === null || item === void 0 ? void 0 : item.title,
                                                                                    separator: ":: ",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                        className: "",
                                                                                        width: 25,
                                                                                        height: 25,
                                                                                        src: whatsapp,
                                                                                        style: {
                                                                                            margin: "0.1em",
                                                                                            padding: "5%",
                                                                                            backgroundColor: "white",
                                                                                            borderRadius: "50%",
                                                                                            cursor: "pointer"
                                                                                        }
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        width: "15%",
                                                        marginRight: "1%"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        style: {
                                                            borderRadius: "25px"
                                                        },
                                                        src: item.imageUrl,
                                                        width: 130,
                                                        height: 130
                                                    })
                                                })
                                            ]
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "PageBuilder-sidebar cate_sidebar",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bannerAddMedia",
                                    style: {
                                        marginTop: "-90px",
                                        width: "70%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-center w_sm_100 bnner_add hide_div_mobile undefined",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "podcastMainImage",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: innerImgUrl || imgUrl,
                                                width: 200,
                                                height: 200,
                                                style: {
                                                    backgroundColor: "#372F1B",
                                                    borderRadius: "20px",
                                                    border: "2px solid #FFFFFF"
                                                }
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    hasMore == true && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center mt-3 mb-4 more_btn",
                        onClick: function() {
                            return loadMoreEpisodes();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn btn-outline-primary",
                            children: "المزيد"
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (Podcast);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1967,9774,2888,179], function() { return __webpack_exec__(19714); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);